import React from 'react';
import Carousel from 'react-native-reanimated-carousel';
import {View} from 'react-native';
import {BannerListItem} from '../home.type';
import theme from '@/style';
import LazyImage from '@basicComponents/image';
import {NativeTouchableOpacity} from '@basicComponents/touchable-opacity';
import {goToUrl} from '@/common-pages/game-navigate';
import {useResponsiveDimensions} from '@/utils';
import {StyleSheet} from 'react-native';

const AnnaBanner = ({bannerList}: {bannerList: BannerListItem[]}) => {
  const {width} = useResponsiveDimensions();
  const bannerWidth = width - 24;
  const bannerHeight = 130;
  const [currentIndex, setCurrentIndex] = React.useState(0);

  if (!bannerList?.length) {
    return <View style={styles.wrap} />;
  }

  return (
    <View style={styles.wrap}>
      <View style={styles.carouselWrap}>
        <Carousel
          loop
          width={bannerWidth}
          height={bannerHeight}
          autoPlay
          autoPlayInterval={5000}
          scrollAnimationDuration={800}
          data={bannerList}
          onProgressChange={offset => {
            let index = Math.abs(Math.round(offset / bannerWidth));
            if (index >= bannerList.length) {
              index = 0;
            }
            if (index !== currentIndex) {
              setCurrentIndex(index);
            }
          }}
          renderItem={({item}) => (
            <NativeTouchableOpacity
              onPress={() =>
                item.skipLinks && goToUrl(item.skipLinks, item.title)
              }
              style={styles.slide}>
              <View style={[styles.banner, {height: bannerHeight}]}>
                <LazyImage
                  imageUrl={item.bannerImg}
                  width={bannerWidth}
                  height={bannerHeight}
                  resizeMode="cover"
                  occupancy={theme.backgroundColor.lightGrey}
                />
              </View>
            </NativeTouchableOpacity>
          )}
        />
      </View>
      <View style={[theme.flex.row, theme.flex.center, styles.dots]}>
        {bannerList.map((_, index) => (
          <View
            key={index}
            style={[
              styles.dot,
              currentIndex === index ? styles.activeDot : styles.inactiveDot,
            ]}
          />
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: {
    height: 142,
    position: 'relative',
  },
  carouselWrap: {
    paddingHorizontal: 12,
    paddingTop: 12,
    overflow: 'hidden',
  },
  slide: {
    width: '100%',
  },
  banner: {
    borderRadius: 8,
    overflow: 'hidden',
    width: '100%',
    backgroundColor: theme.backgroundColor.lightGrey,
  },
  dots: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 20,
    zIndex: 2,
  },
  dot: {
    height: 4,
    borderRadius: 4,
    marginHorizontal: 2,
  },
  activeDot: {
    width: 12,
    backgroundColor: theme.basicColor.primary,
  },
  inactiveDot: {
    width: 4,
    backgroundColor: theme.backgroundColor.lightGrey,
  },
});

export default AnnaBanner;
